import { render, staticRenderFns } from "./bfooter.vue?vue&type=template&id=90fa0c82&scoped=true&"
import script from "./bfooter.vue?vue&type=script&lang=js&"
export * from "./bfooter.vue?vue&type=script&lang=js&"
import style0 from "./bfooter.vue?vue&type=style&index=0&id=90fa0c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fa0c82",
  null
  
)

export default component.exports